import styled from "styled-components";

export const Wrapper = styled("div")(({ theme, $isShowInSmallScreen }) => ({
  ...theme.mixins.flexAlignCenter,
  ...theme.paddings(24),
  justifyContent: "space-between",
  display: $isShowInSmallScreen ? "none" : "flex",
  width: "100%",
  gap: 30,
  backgroundColor: theme.palette.white,
  borderRadius: 8,
  boxShadow: `0 2px 8px ${theme.palette.shadowSm}`,
  border: `1px solid ${theme.palette.bgAlt}`,

  [theme.down("lg")]: {
    display: $isShowInSmallScreen ? "flex" : "none",
  },

  [theme.down("sm")]: {
    ...theme.paddings(20, 15),
  },

  [theme.down("xs")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 10,
  },
}));

export const InfoBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  gap: 30,

  [theme.down("xs")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 10,
  },
}));

export const ItemTitle = styled("div")(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.textSecondary,
  fontWeight: 500,
  marginBottom: 4,
}));

export const ItemValue = styled("div")(({ theme }) => ({
  fontSize: 18,
  color: theme.palette.textPrimary,
  fontWeight: 600,

  "& .order-id": {
    display: "flex",
    padding: "2px 5px",
    color: theme.palette.white,
    backgroundColor: theme.palette.primaryLight,
    fontSize: 16,
  },

  [theme.down("sm")]: {
    fontSize: 16,
  },

  [theme.down("xs")]: {
    fontSize: 15,
  },
}));

export const DownloadBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  justifyContent: "flex-end",

  [theme.down("xs")]: {
    width: "100%",
  },
}));

export const DownloadButton = styled("button")(({ theme }) => ({
  width: 32,
  height: 32,
  borderRadius: "50%",
  border: "none",
  padding: 0,
  margin: 0,
  color: theme.palette.textSecondary,
  backgroundColor: theme.palette.bgPage,
  fontSize: 16,
  cursor: "pointer",
  transition: "all .2s ease",

  "&:hover": {
    backgroundColor: theme.palette.borderLight,
    color: theme.palette.textPrimary,
  },
}));
